module.exports = __webpack_public_path__ + "img/gonglve1.9b38db71.png";